export enum PickupActionEnum {
  BOOK_PICKUP = 'BOOK_PICKUP',
  CANCEL_PICKUP = 'CANCEL_PICKUP',
  CREATE_MANIFEST = 'CREATE_MANIFEST',
  PICKUP_MANIFEST = 'PICKUP_MANIFEST'
}
